import z from 'zod'

export enum FileType {
  CLAIMS = 'CLAIM',
  ABACO = 'ABACUS',
  LUBRIFICANTS = 'LUBRIFICANTS',
  PRICER = 'PRICER',
  OTHER = 'OTHER',
}

export const filesModel = z.object({
  __typename: z.literal('Files').default('Files'),
  id: z.string().uuid(),
  file_type: z.nativeEnum(FileType),
  file_name: z.string(),
  file_url: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  is_active: z.boolean(),
})

export type FilesModel = z.infer<typeof filesModel>
